import styled from 'styled-components';

export default styled.p`
  margin: 3px 0 -3px 0;
  font-size: 14px !important;
  font-weight: bold;
  color: black !important;
`;
